'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'infinity';
var width = 640;
var height = 512;
var aliases = [8734,9854];
var unicode = 'f534';
var svgPathData = 'M0 237.3c0-78 63.3-141.3 141.3-141.3 39 0 76.2 16.1 102.9 44.5L320 221 395.8 140.5C422.5 112.1 459.7 96 498.7 96 576.7 96 640 159.3 640 237.3l0 37.4c0 78-63.3 141.3-141.3 141.3-39 0-76.2-16.1-102.9-44.5L320 291 244.2 371.5C217.5 399.9 180.3 416 141.3 416 63.3 416 0 352.7 0 274.7l0-37.4zM287 256l-77.8-82.6c-17.6-18.7-42.2-29.4-68-29.4-51.5 0-93.3 41.8-93.3 93.3l0 37.4c0 51.5 41.8 93.3 93.3 93.3 25.7 0 50.3-10.6 68-29.4L287 256zm65.9 0l77.8 82.6c17.6 18.7 42.2 29.4 68 29.4 51.5 0 93.3-41.8 93.3-93.3l0-37.4c0-51.5-41.8-93.3-93.3-93.3-25.7 0-50.3 10.6-68 29.4L353 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faInfinity = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;